module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adminVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "企业管理员",
      "width": "950px",
      "visible": _vm.adminVisible,
      "close-on-click-modal": false,
      "before-close": _vm.adminVisibleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.adminVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-key": function (row) { return row.id; },
      "data": _vm.adminList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "xshow-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "softtype",
      "label": "软件类型",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "intime",
      "label": "注册时间",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 88714150)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.adminVisibleClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAdmin.apply(null, arguments)
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.orderUserSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1776f28a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/addAdmin.vue
// module id = 1720
// module chunks = 9